import { render } from "./AdvertiserManagement.vue?vue&type=template&id=6a76dea8&scoped=true"
import script from "./AdvertiserManagement.vue?vue&type=script&lang=js"
export * from "./AdvertiserManagement.vue?vue&type=script&lang=js"

import "./AdvertiserManagement.vue?vue&type=style&index=0&id=6a76dea8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a76dea8"]])

export default __exports__